import { motion } from "framer-motion";
import { EASE } from "../../lib/api";

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.15, ease: EASE, delay: i } }),
};

export const MaskLines = ({ lines, as = "h2", className = "", lineClass, delay = 0, onLoad = false, testId }) => {
  const Tag = motion[as];
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Tag className={className} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.04em]">
          <motion.span className={`block ${lineClass ? lineClass(i) : ""}`} variants={lineVariants} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <p className={`overline flex items-center gap-3 text-[var(--signal)] ${className}`}>
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);
